import React from 'react';
import type { IconProps } from '../types';

export const IconKey: React.FC<IconProps> = ({ size = 20, className = '', color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <circle cx="7" cy="7" r="3.5" stroke={color} strokeWidth="1.5" />
    <path d="M10.5 7H17L16 9H14.5L14 10H12.5L12 11.5" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

